import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Focus from '../views/Focus.vue'
import Processed from '../views/Processed.vue'

const routes = [
  {
    path: '/',
    name: '',
    component: Home
  },
  {
    // make dynamic!
    path: '/manuka',
    name: 'Manuka',
    component: Focus
  },
  {
    path: '/processed',
    name: 'Thank you!',
    component: Processed
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import(/* webpackChunkName: "shop" */ '../views/Cart.vue')
  },
  {
    path: '/terms-conditions',
    name: 'Terms and Conditions',
    component: () => import(/* webpackChunkName: "shop" */ '../views/Terms.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `Sunday Lunch | ${to.name}`;
  next();
});

export default router
